import React from "react";
import { Card, Box, Button, Typography } from "@mui/material";
import { ChevronLeft } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

const SmallModalTemplateHeader = (props) => {
  const theme = useTheme();
  const { title, handleBackClick, showBackButton } = props;

  return (
    <Card sx={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0, boxShadow: 0 }}>
      <Box
        sx={{
          textAlign: "center",
          padding: "16px",
          backgroundColor: theme.palette.common.bgGrey2,
          position: "relative",
        }}
      >
        {showBackButton ? (
          <Button
            variant="outline"
            sx={{
              position: "absolute",
              left: "16px",
              top: "10px",
              padding: "4px 0px",
              backgroundColor: "#fff",
              "&:hover": {
                backgroundColor: "#fff",
              },
            }}
          >
            <ChevronLeft
              fontSize="large"
              sx={{ color: theme.palette.common.greenTwo, cursor: "pointer" }}
              onClick={() => {
                if (handleBackClick) {
                  handleBackClick();
                }
              }}
            />
          </Button>
        ) : null}
        <Typography
          sx={{
            fontSize: "22px",
            fontFamily: "Lato-Regular",
            color: theme.palette.primary.main,
          }}
        >
          {title || "Title"}
        </Typography>
      </Box>
    </Card>
  );
};

export default SmallModalTemplateHeader;
